/* eslint-disable @next/next/no-img-element */
import React from 'react'
import { WhyJoinWrapper } from './styles'
import { Header2, Text, LinkButton } from '../../styles/Components'
import { gsColors } from '../../styles/Variables'
import image from '../../../public/ambassador_banner.jpg'
import Image from 'next/image'

const WhyJoin = () => {
  return (
    <WhyJoinWrapper>
      <div className='why-content'>
        <Header2 margin="0 0 44px 0" color={gsColors.cobalt}>
          The perks
        </Header2>
        <div className="list">
          <div className="list-item">
            <div className="check-box">
              <img src="/images/checkmark_cobalt.svg" alt="checkmark" />
            </div>
            <Text fontSize={24} margin="0 0 0 72px" color={gsColors.cobalt}>
              <b>Receive credits for free glam services</b> that fit into your busy schedule.
            </Text>
          </div>
          <div className="list-item">
            <div className="check-box">
              <img src="/images/checkmark_cobalt.svg" alt="checkmark" />
            </div>
            <Text fontSize={24} margin="0 0 0 72px" color={gsColors.cobalt}>
              <b>Potential for paid opportunities</b> as well as commission on sales.
            </Text>
          </div>
          <div className="list-item">
            <div className="check-box">
              <img src="/images/checkmark_cobalt.svg" alt="checkmark" />
            </div>
            <Text fontSize={24} margin="0 0 0 72px" color={gsColors.cobalt}>
              <b>Services available across 14 U.S. cities</b> (and counting).
            </Text>
          </div>
          <div className="list-item">
            <div className="check-box">
              <img src="/images/checkmark_cobalt.svg" alt="checkmark" />
            </div>
            <Text fontSize={24} margin="0 0 0 72px" color={gsColors.cobalt}>
              <b>Get exclusive invitations</b> to industry and community events—helping you grow your network.
            </Text>
          </div>
          <div className="list-item">
            <div className="check-box">
              <img src="/images/checkmark_cobalt.svg" alt="checkmark" />
            </div>
            <Text fontSize={24} margin="0 0 0 72px" color={gsColors.cobalt}>
              <b>Fast, reliable concierge support</b> for all ambassadors.
            </Text>
          </div>
        </div>
        <LinkButton
          style={{ marginTop: 60 }}
          href='https://connect.glamsquad.com/'
          target='_blank'
          outline
          large
          color={gsColors.cobalt}
        >
          Apply Now
        </LinkButton>
      </div>
      <div className="image-placeholder">
        <Image
          fill
          style={{ objectFit: 'cover '}}
          src={image}
          alt='why-image'
          priority
          quality={100}
        />
      </div>
    </WhyJoinWrapper>
  )
}

export default WhyJoin
